var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreProductNone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 314,
    viewBox: "0 0 392 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.57 313.303C288.516 313.303 354.472 247.621 354.472 166.95C354.2 86.0059 288.516 20.3242 207.57 20.3242C126.352 20.3242 60.668 86.0059 60.668 166.677C60.668 247.621 126.352 313.303 207.57 313.303Z",
    fill: "#F3F1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.016 115.711C364.188 115.711 369.191 110.709 369.191 104.537C369.191 98.3661 364.188 93.3633 358.016 93.3633C351.845 93.3633 346.842 98.3661 346.842 104.537C346.842 110.709 351.845 115.711 358.016 115.711Z",
    fill: "#F3F1FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M374.369 72.1059C378.583 72.1059 382 68.6893 382 64.4748C382 60.2603 378.583 56.8438 374.369 56.8438C370.154 56.8438 366.737 60.2603 366.737 64.4748C366.737 68.6893 370.154 72.1059 374.369 72.1059Z",
    fill: "#F3F1FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1314 265.063C55.9586 265.063 62.3037 258.718 62.3037 250.891C62.3037 243.064 55.9586 236.719 48.1314 236.719C40.3042 236.719 33.959 243.064 33.959 250.891C33.959 258.718 40.3042 265.063 48.1314 265.063Z",
    fill: "#F3F1FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3241_37763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.453 204.311C161.453 216.983 151.205 227.231 138.423 227.231C138.202 227.231 136.329 227.231 122.555 227.231C112.968 227.231 97.6509 227.231 73.1879 227.231H61.5074C46.1905 227.561 33.959 215.33 33.959 200.564C33.959 185.689 46.3007 173.347 61.838 174.119C75.1714 132.467 136.219 138.307 141.398 181.391C152.858 182.824 161.453 192.52 161.453 204.311Z",
    fill: "url(#paint0_linear_3241_37763)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.423 227.234C151.095 227.234 161.454 216.986 161.454 204.314C161.454 191.642 151.095 181.395 138.423 181.395C125.751 181.395 115.393 191.642 115.393 204.314C115.393 216.986 125.751 227.234 138.423 227.234Z",
    fill: "url(#paint1_linear_3241_37763)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.847 227.453C123.436 227.453 141.839 209.161 141.839 186.572C141.839 163.983 123.436 145.691 100.847 145.691C78.2568 145.691 59.8545 163.983 59.8545 186.572C59.8545 209.161 78.1466 227.453 100.847 227.453Z",
    fill: "url(#paint2_linear_3241_37763)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3241_37763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.883 91.9636C197.883 109.445 183.746 123.582 166.112 123.582C165.808 123.582 163.223 123.582 144.221 123.582C130.996 123.582 109.866 123.582 76.1179 123.582H60.0041C38.8738 124.038 22 107.165 22 86.7952C22 66.2735 39.0259 49.2482 60.4602 50.3122C78.8542 -7.14842 163.071 0.908226 170.216 60.3451C186.026 62.3212 197.883 75.6983 197.883 91.9636Z",
    fill: "url(#paint3_linear_3241_37763)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.111 123.585C183.593 123.585 197.883 109.448 197.883 91.9662C197.883 74.4848 183.593 60.3477 166.111 60.3477C148.629 60.3477 134.34 74.4848 134.34 91.9662C134.34 109.448 148.629 123.585 166.111 123.585Z",
    fill: "url(#paint4_linear_3241_37763)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.274 123.887C145.437 123.887 170.824 98.6529 170.824 67.4903C170.824 36.3278 145.437 11.0938 114.274 11.0938C83.1104 11.0938 57.7236 36.3278 57.7236 67.4903C57.7236 98.6529 82.9584 123.887 114.274 123.887Z",
    fill: "url(#paint5_linear_3241_37763)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.757 139.72C156.757 114.19 177.555 93.4338 203.137 93.4338C228.718 93.4338 249.516 114.19 249.516 139.72C249.516 165.25 228.718 186.007 203.137 186.007C177.555 186.007 156.757 165.458 156.757 139.72ZM203.137 52.1289C152.806 52.1289 111.834 93.0187 111.834 143.249C111.834 179.78 160.085 248.898 186.498 274.636C192.322 280.24 200.225 282.523 207.712 281.07C208.336 281.07 208.752 280.862 209.376 280.655C209.584 280.655 209.792 280.655 210 280.447C213.536 279.41 217.071 277.334 219.983 274.636C242.029 253.049 279.257 196.592 290.904 162.552C292.568 157.571 293.816 152.589 294.232 147.815C294.44 146.155 294.44 144.702 294.44 143.041C294.44 93.0187 253.676 52.1289 203.137 52.1289Z",
    fill: "#7647EE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M203.137 302.864C164.661 302.864 125.561 292.694 125.561 273.39C125.561 268.201 128.472 260.729 142.407 254.295C145.111 253.049 148.022 254.295 149.27 256.786C150.518 259.484 149.27 262.39 146.774 263.635C138.663 267.371 135.96 271.107 135.96 273.183C135.96 281.07 162.165 292.279 203.137 292.279C244.109 292.279 270.314 280.863 270.314 273.183C270.314 270.485 266.362 266.126 255.547 261.975C252.844 260.937 251.596 258.031 252.636 255.333C253.676 252.634 256.587 251.389 259.291 252.427C276.969 259.276 280.713 267.579 280.713 273.39C280.713 292.694 241.613 302.864 203.137 302.864Z",
    fill: "#15112D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3241_37763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.19 213.577C369.19 226.248 358.942 236.496 346.16 236.496C345.94 236.496 344.066 236.496 330.292 236.496C320.705 236.496 305.388 236.496 280.925 236.496H269.245C253.928 236.827 241.696 224.596 241.696 209.83C241.696 194.954 254.038 182.613 269.575 183.384C282.909 141.732 343.956 147.572 349.135 190.657C360.595 192.089 369.19 201.786 369.19 213.577Z",
    fill: "url(#paint6_linear_3241_37763)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M346.16 236.499C358.833 236.499 369.191 226.252 369.191 213.58C369.191 200.908 358.833 190.66 346.16 190.66C333.488 190.66 323.13 200.908 323.13 213.58C323.13 226.252 333.488 236.499 346.16 236.499Z",
    fill: "url(#paint7_linear_3241_37763)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.584 236.718C331.174 236.718 349.576 218.427 349.576 195.838C349.576 173.249 331.174 154.957 308.584 154.957C285.994 154.957 267.592 173.249 267.592 195.838C267.592 218.427 285.884 236.718 308.584 236.718Z",
    fill: "url(#paint8_linear_3241_37763)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3241_37763",
    x: 11.959,
    y: 134.789,
    width: 171.494,
    height: 125.449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3241_37763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3241_37763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3241_37763",
    x: 0,
    y: 0.230469,
    width: 219.883,
    height: 156.359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3241_37763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3241_37763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3241_37763",
    x: 219.696,
    y: 144.055,
    width: 171.494,
    height: 125.449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3241_37763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3241_37763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3241_37763",
    x1: 97.706,
    y1: 179.447,
    x2: 97.6645,
    y2: 228.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3241_37763",
    x1: 112.942,
    y1: 176.46,
    x2: 133.358,
    y2: 198.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3241_37763",
    x1: 56.016,
    y1: 167.813,
    x2: 88.1937,
    y2: 180.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3241_37763",
    x1: 109.942,
    y1: 57.6623,
    x2: 109.884,
    y2: 124.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3241_37763",
    x1: 130.959,
    y1: 53.5402,
    x2: 159.123,
    y2: 84.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3241_37763",
    x1: 52.4283,
    y1: 41.6114,
    x2: 96.8187,
    y2: 58.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3241_37763",
    x1: 305.443,
    y1: 188.712,
    x2: 305.402,
    y2: 237.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3241_37763",
    x1: 320.679,
    y1: 185.726,
    x2: 341.095,
    y2: 208.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3241_37763",
    x1: 263.753,
    y1: 177.079,
    x2: 295.931,
    y2: 189.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreProductNone);
export default __webpack_public_path__ + "static/media/store-product-none.21bc52e561aa408b95c2f8ea0ec51292.svg";
export { ForwardRef as ReactComponent };